import XDate from './akenzo-lfs-termin-xdate';

export default class Kalender {
    constructor(...args) {
        this.cfg = {
            id: 'kalender',
            locale: 'de',
            selected: null,
            header: {
                days: 'D',
                show: true,
            },
            events: {
                onDaySelect: null,
                onMonthChange: null,
                onPrevMonth: null,
                onNextMonth: null,
                onLimitLeft: null,
                onLimitRight: null,
            },
            display: {
                showWeekdays: true,
            },
            data: {
                monthPossibilities: {},
            },
            navigation: {
                limitLeft: null,
                limitRight: null,
                topNav: {
                    show: true,
                    titleMonth: 'F Y',
                    titleMonthThisYear: 'F',
                },
            },
        };
        // this.date = arguments.length && arguments[0].hasOwnProperty('date')
        // ? new XDate().from(arguments[0].date) : new XDate();
        this.date = args.length && Object.prototype.hasOwnProperty.call(args[0], 'date')
            ? new XDate().from(args[0].date) : new XDate();
        // this.root = null;
        this.cfg = this.deepMergeObject(this.cfg, args[0]);
        this.date.setLocale(this.cfg.locale);
        // this.init(this.cfg);
        // add global class identifier
        this.class = {
            lorem: '.js-lorem',
        };

        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', this.init.bind(this), false);
        } else {
            this.init(this.cfg);
        }
    }

    /**
     * initialize functions
     */
    init() {
        this.initializedEvent = new Event('initialized', { bubbles: true, cancelable: false });
        this.updatedEvent = new Event('updated', { bubbles: true, cancelable: false });
        this.pleaseReloadEvent = new Event('pleaseReload', { bubbles: true, cancelable: false });
        this.selectEvent = new Event('select', { bubbles: true, cancelable: false });

        this.render();
        this.bindEvents();
    }

    mergeCfg(cfg) {
        let mergedObj = {};
        mergedObj = this.deepMergeObject(this.cfg, cfg);
        return mergedObj;
    }

    deepMergeObject(target, source) {
        // const output = Object.assign({}, target);
        const output = ({ ...target });
        if ((target && typeof target === 'object' && !Array.isArray(target))
            && (source && typeof source === 'object' && !Array.isArray(source))
        ) {
            Object.keys(source).forEach((key) => {
                if (typeof source[key] === 'object' && !Array.isArray(source[key])) {
                    if (!(key in target)) {
                        Object.assign(output, { [key]: source[key] });
                    } else if (target[key] !== null) {
                        output[key] = this.deepMergeObject(target[key], source[key]);
                    } else {
                        output[key] = source[key];
                    }
                } else {
                    Object.assign(output, { [key]: source[key] });
                }
            });
        }
        return output;
    }

    bindEvents() {
        const r = this.root;
        const that = this;
        const prevMonth = r.querySelector("button[class^='prev-month']");
        const nextMonth = r.querySelector("button[class^='next-month']");
        const currentMonth = r.querySelector("div[class^='current-month']");

        prevMonth.addEventListener('click', (evnt) => {
            evnt.preventDefault();
            this.to('-1 month');
        });

        nextMonth.addEventListener('click', (evnt) => {
            evnt.preventDefault();
            this.to('+1 month');
        });

        currentMonth.addEventListener('click', (evnt) => {
            evnt.preventDefault();
            that.root.dispatchEvent(that.pleaseReloadEvent); // .bind(that);
        });
    }

    render() {
        const elemDiv = document.createElement('div');
        const elemBut = document.createElement('button');
        const rootDiv = elemDiv.cloneNode();

        rootDiv.classList.add('lfs-termin-kalender');
        rootDiv.classList.add('initialization');
        rootDiv.setAttribute('id', this.cfg.id);

        const r = rootDiv;
        this.root = rootDiv;
        let xd = this.date.copy();
        // const today = new XDate().to('midnight').getUnixtimestamp();
        let firstOfMonth = this.date.copy().to('first day of month');
        // const lastOfMonth = this.date.copy().to('last day of month').getUnixtimestamp();
        const act = firstOfMonth.copy().to('last Monday');
        // let d;
        // let d2;
        firstOfMonth = firstOfMonth.getUnixtimestamp();

        let otherDiv = elemDiv.cloneNode();

        otherDiv.classList.add('month');
        const d = otherDiv;
        r.appendChild(d);

        let but = elemBut.cloneNode();

        but.classList.add('prev-month', 'rlp-i', 'icon-arrow_left');
        d.appendChild(but);

        otherDiv = elemDiv.cloneNode();
        otherDiv.classList.add('current-month');
        otherDiv.innerHTML = '';
        d.appendChild(otherDiv);

        but = elemBut.cloneNode();
        but.classList.add('next-month', 'rlp-i', 'icon-arrow_right');
        d.appendChild(but);

        otherDiv = elemDiv.cloneNode();
        otherDiv.classList.add('body');
        const body = otherDiv;
        r.appendChild(body);

        if (this.cfg.display.showWeekdays) {
            otherDiv = elemDiv.cloneNode();
            otherDiv.classList.add('weekwrap');
            const w = otherDiv;
            body.appendChild(w);

            otherDiv = elemDiv.cloneNode();
            otherDiv.classList.add('kw');
            otherDiv.innerText = 'KW';
            w.appendChild(otherDiv);

            otherDiv = elemDiv.cloneNode();
            otherDiv.classList.add('weeks');
            const weeks = otherDiv;
            w.appendChild(weeks);

            otherDiv = elemDiv.cloneNode();
            for (let i = 0; i < 6; i += 1) {
                otherDiv = elemDiv.cloneNode();
                otherDiv.classList.add('day');
                otherDiv.innerHTML = i;
                weeks.appendChild(otherDiv);
            }
        }

        otherDiv = elemDiv.cloneNode();
        otherDiv.classList.add('calendar-wrap');
        const c = otherDiv;
        body.appendChild(c);

        otherDiv = elemDiv.cloneNode();
        otherDiv.classList.add('weekdays');
        const wd = otherDiv;
        c.appendChild(wd);

        const wdr = elemDiv.cloneNode();
        wdr.classList.add('weekdays-wrap');
        // d = otherDiv;
        wd.appendChild(wdr);

        xd.to('next Monday');
        for (let i = 0; i < 7; i += 1) {
            otherDiv = elemDiv.cloneNode();
            otherDiv.innerHTML = xd.date('D');
            wdr.append(otherDiv);
            xd.to('+1 day');
        }

        otherDiv = elemDiv.cloneNode();
        otherDiv.classList.add('days');
        const days = otherDiv;
        c.appendChild(days);

        otherDiv = elemDiv.cloneNode();
        otherDiv.classList.add('days-wrap');
        const dayswr = otherDiv;
        days.appendChild(dayswr);

        xd = this.date.copy();
        xd.to('last Monday');

        // let css, uts, e, s;
        for (let i = 0; i < 42; i += 1) {
            but = elemBut.cloneNode();
            dayswr.appendChild(but);
            act.to('+1 day');
        }
        this.cfg.parent.appendChild(r);

        this.update();
        r.classList.remove('initialization');
        r.classList.add('initialized');
        r.dispatchEvent(this.initializedEvent);
    }

    getRoot() {
        return this.root;
    }

    to(value) {
        let newDate;
        newDate = this.date.copy().to(value);
        if (typeof value === 'string') {
            newDate = this.date.copy().to(value);
        }
        if (this.cfg.events.onMonthChange) {
            this.cfg.events.onMonthChange(new CustomEvent('onMonthChange'), newDate.getUnixtimestamp(), newDate);
        }
    }

    set(...args) {
        const [x, y] = args;
        let properties;

        if (args.length === 2) {
            // properties[arguments[0]] = arguments[1];
            properties[x] = y;
        } else {
            properties = x;
        }
        this.cfg = this.deepMergeObject(properties);

        return this;
    }

    getSelectedDays() {
        return this.root.querySelector("button[class^='day selected']");
    }

    getDate() {
        return this.date;
    }

    selectDay(...args) {
        let d;
        const [x] = args;

        if (this.root.querySelector("button[class*='selected']") !== null) {
            this.root.querySelector("button[class*='selected']").classList.remove('selected');
        }
        if (typeof x === 'object') {
            d = x;
            x.classList.add('selected');
        }
        if (typeof x === 'string') {
            d = this.root.querySelector(`data-t="${x}"`);
            d.classList.add('selected');
        }
        this.root.dispatchEvent(new CustomEvent('select', [d.dataset.t, parseInt(d.innerHTML, 10)]));

        if (this.cfg.events.onDaySelect) {
            this.cfg.events.onDaySelect(new CustomEvent('selected'), d.dataset.t, parseInt(d.innerHTML, 10));
        }

        return this.date;
    }

    updateNavigation() {
        if (this.cfg.navigation.limitLeft) {
            const prevMonth = this.root.querySelector("button[class^='prev-month']");

            if (this.date.compare('<=', this.cfg.navigation.limitLeft)) {
                prevMonth.classList.add('hidden');
            } else {
                prevMonth.classList.remove('hidden');
            }
        }
        if (this.cfg.navigation.limitRight) {
            const nextMonth = this.root.querySelector("button[class^='next-month']");

            if (this.date.compare('>=', this.cfg.navigation.limitRight)) {
                nextMonth.classList.add('hidden');
            } else {
                nextMonth.classList.remove('hidden');
            }
        }
    }

    update(...args) {
        const that = this;
        this.date.setLocale(this.cfg.locale);
        if (args.length) {
            this.cfg = this.deepMergeObject(args[0]);
            this.date.from(args[0].date).to('first day of month');
        }
        this.root.querySelector("div[class='current-month']").innerHTML = this.date.date(this.cfg.navigation.topNav.titleMonth);

        if (this.cfg.display.showWeekdays) {
            const date = this.date.copy();
            const weeks = this.root.querySelector("div[class='weeks']");

            Array.from(weeks.children).forEach((d) => { // each(function (i, d) {
                d.innerHTML = date.date('W');
                date.to('+1 week');
            });
        }

        const today = new XDate().to('midnight').getUnixtimestamp();
        let firstOfMonth = this.date.copy().to('first day of month');
        const lastOfMonth = this.date.copy().to('last day of month').getUnixtimestamp();
        const act = firstOfMonth.copy().to('last Monday');
        let css;
        let uts;
        firstOfMonth = firstOfMonth.getUnixtimestamp();

        const daysWrap = this.root.querySelector("div[class='days-wrap']");

        Array.from(daysWrap.children).forEach((button) => {
            button.setAttribute('disabled', true);
            css = ['day'];
            uts = act.getUnixtimestamp();
            if (uts === that.cfg.selected) {
                css.push('selected');
            }
            if (uts < firstOfMonth) {
                css.push('before');
                css.push('month-before');
            } else if (uts > lastOfMonth) {
                css.push('after');
            } else if (uts < today) {
                css.push('before');
                css.push('before-today');
            }
            // if (that.cfg.data.monthPossibilities.hasOwnProperty(uts)
            if (Object.prototype.hasOwnProperty.call(that.cfg.data.monthPossibilities, uts)
                && that.cfg.data.monthPossibilities[uts]
            ) {
                css.push('possible');
                button.removeAttribute('disabled');
                button.addEventListener('click', (evnt) => {
                    evnt.preventDefault();
                    const d = evnt.target;
                    that.selectDay(d);
                }); // .bind(e));
            }
            button.innerHTML = (act.date('d'));
            button.setAttribute('class', css.join(' '));
            button.setAttribute('data-t', uts);

            act.to('+1 day');
        });

        this.updateNavigation();
        this.root.classList.remove('initialized');
        this.root.dispatchEvent(this.updatedEvent);
    }
}
